import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { makeSelectObject, requestObject } from '../../../../store/Object';
import { requestObjects } from '../../../../store/Objects';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import TemplateEditForm, { DispatchPropsType, MapStateType } from '../organisms/templates/templateEditForm';

const mapStateToProps = () => {
    return (state: IStateType) => ({
        params: getParams(state),
        templateViewDetails: makeSelectObject(Instances.smsTemplateView)(state) || {},
        data: state.SMSTemplates
    });
};

const mapDispatchToProps = {
    onClose: () => closeSideBar(),
    onLoad: () => requestObjects(Instances.smsTemplate),
    onSave: (editTemplateData: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.smsTemplateApply, undefined, undefined, 'PUT', true, true, editTemplateData, callback),
    onShortenUrl: (urlOb: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.smsTemplateUrlShortener, undefined, undefined, 'POST', true, true, urlOb, callback),
    onFileShortener: (payload: any, callback: (resp: any, flag: boolean) => void) => requestObject(Instances.smsTemplateFileShortener, undefined, undefined, 'POST', true, true, payload, callback)
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(TemplateEditForm));